<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button @click="signOut" color="light">Đăng xuất</ion-button>
        </ion-buttons>
        <ion-title color="light">Mở khóa</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="slide-container">
        <div class="content">
          <div>
            <div class="reminder">
              <ion-label>Bạn đang đăng nhập dùng số điện thoại</ion-label><br>
              <ion-label>{{ $utils.obfuscatedPhone(phoneNumber) }}</ion-label>
            </div>
            <div class="verify">
              <ion-label>Vui lòng nhập mật mã PIN của bạn</ion-label>
              <ion-input ref="verifyInput" inputmode="numeric" type="password" pattern="[0-9]{6}" maxlength="6" v-model="pinNumber" @ionChange="checkPinNumber" :disabled="inputDisabled"></ion-input>
              <p>
                <small>Mã PIN là mật khẩu của bạn để mở khóa ứng dụng Gimolott,<br>được tạo khi bạn đăng ký tài khoản, bao gồm 6 chữ số</small>
                <br>
                <br>
                <br>
                <span style="color: #fff; font-weight: bold; text-decoration: underline" @click="$router.push('/account/personal/changepin')">
                  Quên mã PIN? Bấm vào đây ››
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style scoped>
  ion-toolbar, ion-content {
    --background: #5F021F;
    --color: #fff;
    text-align: center;
  }

  .slide-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 98%;
    width: 98%;
  }
  .slide-container .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
  }
  .content ion-input {
    --background: #fff;
    border-radius: 50px;
    margin-top: 2vh;
    text-align: center;
    --color: #222;
    --padding-start: 2vw;
    --padding-end: 2vw;
    font-size: 1.2em;
  }
  .verify {
    margin-top: 10vh;
    margin-bottom: 20vh;
  }
</style>

<script>
  import {
    IonPage,
    IonContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonLabel,
    IonInput,
  } from '@ionic/vue';
  import { defineComponent } from 'vue';
  import authService from '@/services/auth';
  import { Plugins } from "@capacitor/core";

  export default defineComponent({
    name: 'Unlock',
    components: {
      IonPage,
      IonContent,
      IonHeader,
      IonToolbar,
      IonButtons,
      IonButton,
      IonTitle,
      IonLabel,
      IonInput,
    },
    data() {
      return {
        phoneNumber: '0000000000',
        pinNumber: '',
        inputDisabled: false,
      }
    },
    async mounted() {
      this.phoneNumber = authService.user().phoneNumber.replace(/^\+84/i, '0');
      await this.$store.commit('auth_update_info', {
        phone: this.phoneNumber,
      });
      const { Storage } = Plugins;
      const savedPinRef = await Storage.get({key: 'saved_pin'});
      if (savedPinRef.value) {
        this.checkPinNumber({ detail: { value: savedPinRef.value }});
      }
    },
    methods: {
      async signOut() {
        await authService.requestLogout();
      },
      async checkPinNumber(ev) {
        const pin = ev.detail.value;
        if (pin.length == 6) {
          this.inputDisabled = true;
          await this.$utils.showLoading();
          const ret = await authService.checkPinNumber(pin);

          if (ret) {
            authService.unlocked = true;
            await this.$store.commit('auth_update_info', {
              'pin': this.pinNumber + ''
            });
            this.$router.push('/tabs/main');
            this.pinNumber = '';
            this.inputDisabled = false;
            await this.$utils.hideLoading();
          } else {
            this.pinNumber = '';
            this.$refs.verifyInput.$el.value = '';
            this.$refs.verifyInput.$el.blur();
            console.log(pin);
            this.inputDisabled = false;

            await this.$utils.hideLoading();
          }
        }
      }
    }
  });
</script>
